import { STEPS } from "../../data/landingContent";
import Reveal from "./Reveal";

export default function HowItWorks() {
  return (
    <section aria-labelledby="how-heading">
      <div className="wrap">
        <span className="kicker">Getting started</span>
        <h2 className="section-title" id="how-heading">
          Live in your clinic, <b>without the chaos</b>
        </h2>

        <Reveal as="div" className="steps reveal-stagger">
          {STEPS.map((s) => (
            <div className="step" key={s.n}>
              <div className="n">{s.n}</div>
              <h3>{s.title}</h3>
              <p>{s.desc}</p>
            </div>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
